export const IconObjectId = 'Icon';

export enum IconObjectAttributes {
  BLOB = 'blob',
  TITLE = 'title',
  TAGS = 'tags',
}
